/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Discount_Code_PlaceholderInputs */

const en_directory_submit_discount_code_placeholder = /** @type {(inputs: Directory_Submit_Discount_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. VIBE20`)
};

const zh_directory_submit_discount_code_placeholder = /** @type {(inputs: Directory_Submit_Discount_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如 VIBE20`)
};

/**
* | output |
* | --- |
* | "e.g. VIBE20" |
*
* @param {Directory_Submit_Discount_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_discount_code_placeholder = /** @type {((inputs?: Directory_Submit_Discount_Code_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Discount_Code_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_discount_code_placeholder(inputs)
	return zh_directory_submit_discount_code_placeholder(inputs)
});
export { directory_submit_discount_code_placeholder as "directory.submit.discount_code_placeholder" }